import * as React from "react";
const SVGComponent = ({ color = "#BC9B6A", width = "21px", height = "28px", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 21 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.91887 12.6232L7.3402 12.3984L8.21106 14.1402L9.70003 11.9489L6.77837 7.53805L2.31149 0.711232C2.11474 0.402189 1.66538 0.289904 1.35635 0.486456C0.401208 1.04828 0.00789388 2.20018 0.401208 3.21156L3.63191 11.4712C4.10948 12.7916 5.68271 13.3254 6.91889 12.6231L6.91887 12.6232Z"
      fill={color}
    />
    <path
      d="M12.369 15.9941L10.7676 19.2811L14.0826 25.9675C14.5881 26.9789 15.8243 27.3722 16.8077 26.8103L16.9762 26.698C17.9596 26.1362 18.2686 24.8438 17.6223 23.9167L12.369 15.9941Z"
      fill={color}
    />
    <path
      d="M20.0668 2.79049C19.7858 2.53769 19.3645 2.62196 19.1677 2.931C19.1677 2.931 16.6394 7.11704 15.9088 8.29694C15.7965 8.46547 15.5717 8.52171 15.4032 8.43745C15.2347 8.32516 15.1504 8.10038 15.2627 7.93186C15.937 6.69567 18.2688 2.42545 18.2688 2.42545C18.4374 2.11641 18.2969 1.72311 17.9318 1.58259C17.679 1.49832 17.3979 1.61061 17.2575 1.83539L13.9985 7.20132C13.8862 7.36985 13.6615 7.4261 13.4929 7.34183C13.3244 7.22954 13.2401 7.00476 13.3524 6.83624C14.0267 5.60006 16.3586 1.32984 16.3586 1.32984C16.5271 1.02079 16.3866 0.62749 16.0215 0.48697C15.7687 0.402703 15.4877 0.514993 15.3472 0.73977L11.8917 6.41474L11.4704 7.17332C11.0208 7.93191 10.8803 8.83081 11.0771 9.53316L11.4984 11.0501L2.81739 23.889C2.19932 24.8442 2.48032 26.1084 3.4635 26.6704L3.63203 26.7827C4.61542 27.3445 5.87959 26.9794 6.35714 25.9398L13.1278 12.0052L14.6447 11.6119C15.3751 11.4152 16.0494 10.8533 16.499 10.095L16.9203 9.33637L20.095 3.52094C20.3195 3.26814 20.2915 2.95911 20.0667 2.79055L20.0668 2.79049Z"
      fill={color}
    />
  </svg>
);
export default SVGComponent;